import * as React from 'react';
import ReactTooltip, { TooltipProps } from 'react-tooltip';
import styled from 'styled-components';

import TooltipVariantsStyle from './TooltipVariantsStyle';
import BodyPortal from './BodyPortal';

// @TODO this is an OBSOLETE implementation of the tooltip,
// refactor its usage to sdk Tooltip and drop the damn thing

const StyledTooltip = styled(ReactTooltip)`
  white-space: pre-wrap;
  max-width: 180px;
  padding: 10px;
  font-weight: 600;
  font-size: 11px;

  ${TooltipVariantsStyle}

  &.show {
    opacity: 1;
  }
`;

type Props = {
  attachToBody?: boolean;
} & TooltipProps;

const Tooltip: React.FC<React.PropsWithChildren<Props>> = ({
  attachToBody,
  className,
  type = 'info',
  ...restProps
}) => {
  if (attachToBody) {
    return (
      <BodyPortal>
        <StyledTooltip effect="solid" className={className} type={type} {...restProps} />
      </BodyPortal>
    );
  }

  return <StyledTooltip effect="solid" className={className} type={type} {...restProps} />;
};

export default Tooltip;
